
















import {Component, Vue, Inject} from 'vue-property-decorator';
import {EditDialogsConfig} from '@/models/FlexGridModel';

@Component
export default class FlexGridHeaderEditDialogsConfigDropdownMenu extends Vue {
    @Inject() editDialogsConfig!: EditDialogsConfig | undefined;
    @Inject() moduleName!: string;

    get transpose(): boolean {
        return this.$store.state[this.moduleName].transpose;
    }
}
